<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-filter-item-source" v-if="filter">
    <el-dropdown-item class="checkbox-item">
      <span class="filter-title">{{filter.label}}:</span>
      <el-checkbox-group v-model="filter.value" :min="1">
        <el-checkbox v-for="item in filter.dataSource" :label="item.key" :key="item.key" :class="item.key" :ref="item.key" @change="handleChange(item)">{{item.label}}</el-checkbox>
      </el-checkbox-group>
    </el-dropdown-item>
  </div>
</template>

<script>
export default {
  name: 'wy-filter-item-source',
  props: ["filter", "allFilters"],

  methods: {
    handleChange(item) {
      let filter = this.filter;
      let hasBOTtoLC = filter.value.includes('BotToLC');
      let hasLC = filter.value.includes('LCOnly');
      let hasBot = filter.value.includes('BOT');
      let hasContainedBot = filter.value.includes('BotOnlyContained');
      let hasEscalatedNoLC = filter.value.includes('BotOnlyEscalated');
      if(item.key == 'BOT') {
        if(hasBot && !this.$refs.BOT[0].$el.classList.contains("is-disabled")){
          if(!hasContainedBot) {
            filter.value.push('BotOnlyContained');
          }
          if(!hasEscalatedNoLC) {
            filter.value.push('BotOnlyEscalated');
          }
          if(hasContainedBot && hasEscalatedNoLC) {
            let index = filter.value.indexOf('BOT');
            if (index !== -1) {
              filter.value.splice(index, 1);
            }
            if(hasContainedBot) {
              let index = filter.value.indexOf('BotOnlyContained');
              filter.value.splice(index, 1);
            }
            if(hasEscalatedNoLC) {
              let index = filter.value.indexOf('BotOnlyEscalated');
              filter.value.splice(index, 1);
            }
          }
        }
        else if(hasBOTtoLC || hasLC){
          if(hasContainedBot) {
            let index = filter.value.indexOf('BotOnlyContained');
            filter.value.splice(index, 1);
          }
          if(hasEscalatedNoLC) {
            let index = filter.value.indexOf('BotOnlyEscalated');
            filter.value.splice(index, 1);
          }
        }
        else {
          if (!filter.value.includes('BOT')) {
            filter.value.push('BOT')
          }
        }
      }
      else {
        if((hasContainedBot || hasEscalatedNoLC)) {
          if (!filter.value.includes('BOT')) {
            filter.value.push('BOT')
          }
        }
        else {
          if((hasBOTtoLC || hasLC)) {
            let index = filter.value.indexOf('BOT');
            if (index !== -1) {
              filter.value.splice(index, 1);
            }
          }
          else {
            filter.value.push(item.key);
          }
        }
      }
      hasBot = filter.value.includes('BOT');
      if(hasBot && !hasBOTtoLC && !hasLC) {
        this.allFilters.agentGroups.value = [];
        this.allFilters.agentQueues.value = [];
      }
      this.handleDisableCheckbox();
    },

    handleDisableCheckbox() {
      let filter = this.filter;
      let hasBOTtoLC = filter.value.includes('BotToLC');
      let hasLC = filter.value.includes('LCOnly');
      let hasContainedBot = filter.value.includes('BotOnlyContained');
      let hasEscalatedNoLC = filter.value.includes('BotOnlyEscalated');
      if(!hasBOTtoLC && ! hasLC) {
        this.$refs.BOT[0].$el.classList.add("is-disabled")
        if((!hasContainedBot || !hasEscalatedNoLC) && this.$refs.BotOnlyContained && this.$refs.BotOnlyEscalated) {
          if(hasContainedBot) {
            this.$refs.BotOnlyContained[0].$el.classList.add("is-disabled")
            this.$refs.BotOnlyEscalated[0].$el.classList.remove("is-disabled")
          }
          if(hasEscalatedNoLC) {
            this.$refs.BotOnlyEscalated[0].$el.classList.add("is-disabled")
            this.$refs.BotOnlyContained[0].$el.classList.remove("is-disabled")
          }
        }
        else {
          this.$refs.BotOnlyEscalated[0].$el.classList.remove("is-disabled")
          this.$refs.BotOnlyContained[0].$el.classList.remove("is-disabled")
        }
      }
      else {
        this.$refs.BOT[0].$el.classList.remove("is-disabled")
        this.$refs.BotOnlyEscalated[0].$el.classList.remove("is-disabled")
        this.$refs.BotOnlyContained[0].$el.classList.remove("is-disabled")
      }
    }
  },
  mounted() {
    this.handleDisableCheckbox();
  }
}
</script>

